import { EngineTheme } from '@websky/core/src/theme';
import BaseButtons from './components/BaseComponents/Button/Button.css';
import LoginPage from './components/Account/LoginPage/LoginPage.css';
import Account from './components/Account/Account.css';
import FFP from './components/Account/FFP/FFP.css';
import Modal from './components/Account/Modal/Modal.css';
import Link from './components/BaseComponents/Link/Link.css';
import Input from './components/Input/Input.css';
import PassengerSwitch from './components/Passenger/components/Field/Switch/Switch.css';
import SexSelector from './components/BaseComponents/SexSelector/SexSelector.css';
import MilesRecoveryContent from './components/MilesRecovery/MilesRecoveryContent/MilesRecoveryContent.css';
import MobileDialog from './components/Shared/MobileDialog//MobileDialog.css';
import FirstLoginAgreement from './components/Account/LoginPage/FirstLoginAgreement/FirstLoginAgreement.css';
import Loyalty from './components/Loyalty/Loyalty.css';

const accountTheme: EngineTheme = {
	TravellerForm: {
		TravellerForm: {
			saveButton: BaseButtons.smallBrand
		}
	},
	LoyaltyInfo: {
		Card: {
			wrapper: FFP.wrapper,
			gold: FFP.gold,
			silver: FFP.silver
		},
		FfpInfo: {
			links: FFP.links,
			text: FFP.text,
			footer: FFP.footer,
			button: BaseButtons.smallBrand,
			button_gray: BaseButtons.smallSecondary
		},
		LoyaltyInfo: {
			container: FFP.container
		},
		LoyaltyInfoV2: {
			Card: {
				overlay: FFP.wrapper,
				gold: FFP.gold,
				silver: FFP.silver,
				diamond: FFP.diamond,
				temporary: FFP.temporary,
				header: FFP.header,
				info: FFP.info
			}
		}
	},
	OrderCard: {
		CommonItem: {
			root: Account.orderCard__item
		},
		OrderCard: {
			container: Account.orderCard__header,
			passengers: Account.orderCard__passengers,
			item: Account.orderCard__item,
			buttons: Account.orderCard__buttons
		},
		OrderPreview: {
			city: Account.orderPreview__city,
			main_city: Account.orderPreview__mainCity,
			period: Account.orderPreview__period
		},
		OrderBooking: {
			root: Account.orderBooking__root,
			type_account: Account.orderBooking__typeAccount
		},
		DeleteOrderModal: {
			header__text: Modal.header__text,
			message__text: Modal.message__text
		}
	},
	LoginPage: {
		LoginForm: {
			root: LoginPage.root,
			title: LoginPage.title,
			text: LoginPage.text,
			row: LoginPage.row,
			button_wrapper: LoginPage.button_wrapper,
			social_wrapper: LoginPage.social_wrapper
		},
		FirstLoginAgreement: {
			root: FirstLoginAgreement.root
		}
	},

	Button: {
		ActionButton: {
			button: BaseButtons.optionAction
		}
	},
	Loyalty: {
		LoyaltyConnect: {
			block__header__subtitle: Account.text__accented,
			agreementCheckboxWrapper: Loyalty.loyaltyConnect__agreementCheckboxWrapper
		}
	},
	BaseComponents: {
		Button: {
			smallNeitral: BaseButtons.smallNeitral,
			optionEdit: BaseButtons.optionEdit,
			optionAction: BaseButtons.optionAction,
			smallPrimary: BaseButtons.smallPrimary,
			smallSecondary: BaseButtons.smallSecondary,
			smallBrand: BaseButtons.smallBrand,
			action: BaseButtons.action,
			secondary: BaseButtons.secondary
		},
		SexSelector: {
			checked: SexSelector.checked,
			label: SexSelector.label,
			error: SexSelector.error
		}
	},
	ModalConfirm: {
		ModalConfirm: {
			header: Modal.header__text,
			content: Modal.message__text
		}
	},
	Modal: {
		Modal: {
			modal: Modal.modal
		}
	},
	Link: {
		Link: {
			link: Link.link
		}
	},
	Input: {
		Input: {
			root: Input.boxLabelIn,
			label_shrink: Input.label_shrink,
			input: Input.input,
			input_filled: Input.input_filled,
			real_input: Input.real_input,
			underline: Input.underline
		}
	},
	Passenger: {
		PassengerSwitch: {
			container: PassengerSwitch.container,
			element: PassengerSwitch.element,
			element_active: PassengerSwitch.element_active,
			element_error: PassengerSwitch.element_error
		}
	},
	MilesRecovery: {
		MilesRecoveryContentStyles: {
			wrapper: MilesRecoveryContent.wrapper,
			header: MilesRecoveryContent.header
		}
	},
	Shared: {
		MobileDialog: {
			mobileDialog__header: MobileDialog.mobileDialog__header
		}
	}
};

export default accountTheme;
